import React from "react"
import FormattedMessage from "@irati/utils/lang"
import {Label} from "@irati/ui/src/Typography"
import notify from "@irati/utils/notify"
import {TextButton} from "@irati/ui/src/Button"
import tokens from "@irati/auth/services/tokens"
import passwordService from "@irati/auth/services/password"
import userService from "@irati/identity/services/users"
import {getQuery} from "../../../helpers/getOnboardingQuery"

interface Props {
  body: string
}

const RequestNewLinkButton: React.FC<Props> = (props) => {
  const {uuid} = getQuery()

  const handleRequest = async() => {
    try {
      tokens.clear()
      const user = await userService.unAuthedUser(uuid)
      await passwordService.forgot(user.email, {uuid: user.businessId})
      notify.success({message: "Email sent"})
    } catch (e) {
      notify.error({message: "Something went wrong"})
    }
  }

  const link = (
    <TextButton inline onClick={handleRequest}>
      <Label weight="bold" uppercase>
        <FormattedMessage id="onboarding.old.linkText" />
      </Label>
    </TextButton>
  )

  /* eslint-disable @tooling/perkbox/i18n */
  return <FormattedMessage id={props.body} values={{link}} />
  /* eslint-enable @tooling/perkbox/i18n */
}

export default RequestNewLinkButton
